/**
 * [isNullOrPositiveNumber Return true if a value is a number equal or superior to zero]
 * @param  {number}  value [Value to test]
 * @return {Boolean}
 */
export function isNullOrPositiveNumber(value) {
    if (typeof(value) === "number") {
        if (value >= 0) {
            return true;
        }
    }

    return false;
}
